import React from "react";

export enum NavigationPath {
  home = "/",
  team = "/team",
  biologicalAge = "/biologicalAge",
  insurers = "/insurers",
  socialShare = "/social/:id",
  leagueInvite = "/invite-details/:id",
  biologicalAgeCheckLanding = "/bio",
  bioageLiveLanding = "/bioageLive",
  activityRejuvenatesLanding = "/activityRejuvenates",
  activityRejuvenatesByLanding = "/activityRejuvenatesBy",
  deleteAccount = "/deleteAccount",
}

export const NavigationPathUtils = {
  needsCookieConsent(pathname: string) {
    const cookielessPathnames: string[] = [
      NavigationPath.biologicalAgeCheckLanding,
      NavigationPath.bioageLiveLanding,
      NavigationPath.activityRejuvenatesLanding,
      NavigationPath.activityRejuvenatesByLanding,
    ];
    return !cookielessPathnames.includes(pathname);
  },
};

export const careersUrl = "http://www.lab4.life/positions-open.html";
export const facebookPageUrl = "https://www.facebook.com/vikalife";

export const LogoIcon: React.FC = () => (
  <div
    style={{
      ...makeIconStyle("/home/logo-blue.svg"),
    }}
  />
);

export const LogoWide: React.FC = () => (
  <div
    style={{
      ...makeIconStyle("/home/logo-wide-blue.png", 40, 110),
    }}
  />
);

export const FacebookIcon: React.FC = () => (
  <div
    style={{
      ...makeIconStyle("/home/facebook-blue.svg", 28, 28),
      marginLeft: 6,
    }}
  />
);

const makeIconStyle = (
  imageUrl: string,
  height: number = 42,
  width: number = 42,
) => ({
  display: "block",
  height: height,
  width: width,
  backgroundImage: `url(${imageUrl})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "contain",
});

export function stripSlash(path: string): string {
  if (path !== "/" && path.endsWith("/")) {
    return path.slice(0, path.length - 1);
  } else return path;
}
